import { TGroupedHome } from './or-model-home-grid.types';

export const orModelHomeGridMockData = {
  Abigail: [
    {
      indexName: 'dev_house_plans_elevations',
      BaseElevationPrice: 12345,
      Depth: 63,
      ExteriorStyle: {
        Id: 5,
        ExteriorStyleCategoryId: 7,
        Name: 'Coastal',
      },
      FloorPlans: [
        {
          BasePrice: 537105,
          ElevationId: 9,
          FloorPlanImages: [
            {
              FileName:
                'https://static.schumacherhomes.com/public/assets/floorplanimages/ABIGAIL-FIRST-FLOOR_CAR.jpg',
              Type: 'Main Story',
              TypeId: 1,
            },
            {
              FileName:
                'https://static.schumacherhomes.com/public/assets/floorplanimages/ABIGAIL-SECOND-FLOOR.jpg',
              Type: 'Second Story',
              TypeId: 2,
            },
            {
              FileName:
                'https://static.schumacherhomes.com/public/assets/floorplanimages/ABIGAIL-SECOND-FLOOR-JACK-AND-JILL-BATH.jpg',
              Type: 'Design Idea',
              TypeId: 5,
            },
            {
              FileName:
                'https://static.schumacherhomes.com/public/assets/floorplanimages/ABIGAIL-SECOND-FLOOR-WITH-2-BATHS.jpg',
              Type: 'Design Idea',
              TypeId: 5,
            },
            {
              FileName:
                'https://static.schumacherhomes.com/public/assets/floorplanimages/rABIGAILmultigen.jpg',
              Type: 'Design Idea',
              TypeId: 5,
            },
          ],
          HasModelHome: true,
          Id: 342,

          PlanId: 3,
          PopularRank: 5,
          StudioId: 13,
        },
        {
          BasePrice: 537105,
          ElevationId: 9,
          FloorPlanImages: [
            {
              FileName:
                'https://static.schumacherhomes.com/public/assets/floorplanimages/ABIGAIL-FIRST-FLOOR_CAR.jpg',
              Type: 'Main Story',
              TypeId: 1,
            },
            {
              FileName:
                'https://static.schumacherhomes.com/public/assets/floorplanimages/ABIGAIL-SECOND-FLOOR.jpg',
              Type: 'Second Story',
              TypeId: 2,
            },
            {
              FileName:
                'https://static.schumacherhomes.com/public/assets/floorplanimages/ABIGAIL-SECOND-FLOOR-JACK-AND-JILL-BATH.jpg',
              Type: 'Design Idea',
              TypeId: 5,
            },
            {
              FileName:
                'https://static.schumacherhomes.com/public/assets/floorplanimages/ABIGAIL-SECOND-FLOOR-WITH-2-BATHS.jpg',
              Type: 'Design Idea',
              TypeId: 5,
            },
            {
              FileName:
                'https://static.schumacherhomes.com/public/assets/floorplanimages/rABIGAILmultigen.jpg',
              Type: 'Design Idea',
              TypeId: 5,
            },
          ],
          HasModelHome: true,
          Id: 342,
          PlanId: 3,
          PopularRank: 5,
          StudioId: 13,
        },
      ],
      Id: 9,
      Image:
        'https://static.schumacherhomes.com/public/assets/homes/Exterior_Abigail_Charleston.jpg',
      IsBaseElevation: false,
      IsPopular: false,
      IsPreferred: false,
      Name: 'Abigail Coastal',
      PopularRank: 0,
      SquareFeet: 3243,
      Width: 60,
      HasFloorPlans: true,
      Plan: {
        Bathrooms: 2,
        Bedrooms: 4,
        Collection: null,
        FlexRoom: true,
        FlexRoomIsBedroom: true,
        HasGarage: true,
        Id: 3,
        IsMultiGen: true,
        Name: 'Abigail',
        SimilarPlans: [
          {
            SimilarPlanId: 77,
          },
          {
            SimilarPlanId: 96,
          },
          {
            SimilarPlanId: 140,
          },
        ],
        Stories: [
          {
            Id: 4,
            Name: "2 Story Owner's Retreat Down",
          },
          {
            Id: 7,
            Name: "Dual Owner's Retreat",
          },
        ],
      },
      objectID: '3_9_13',
    },
  ],
  Belleville: [
    {
      indexName: 'dev_house_plans_elevations',
      BaseElevationPrice: 12345,
      Depth: 44,
      ExteriorStyle: {
        Id: 5,
        Name: 'Coastal',
        ExteriorStyleCategoryId: 7,
      },
      FloorPlans: [
        {
          BasePrice: 642458,
          ElevationId: 564,
          FloorPlanImages: [
            {
              FileName:
                'https://static.schumacherhomes.com/public/assets/floorplanimages/BELLEVILLE_FIRST-FLOOR_CAR.jpg',
              Type: 'Main Story',
              TypeId: 1,
            },
            {
              FileName:
                'https://static.schumacherhomes.com/public/assets/floorplanimages/BELLEVILLE_SECOND_FLOOR.jpg',
              Type: 'Second Story',
              TypeId: 2,
            },
            {
              FileName:
                'https://static.schumacherhomes.com/public/assets/floorplanimages/BELLEVILLE-FLEX-ROOM_CAR.jpg',
              Type: 'Design Idea',
              TypeId: 5,
            },
            {
              FileName:
                'https://static.schumacherhomes.com/public/assets/floorplanimages/BELLEVILLE-MULTIGEN_CAR.jpg',
              Type: 'Design Idea',
              TypeId: 5,
            },
          ],
          HasModelHome: true,
          Id: 11863,
          IsPopular: true,
          IsPreferred: true,
          PlanId: 164,
          PopularRank: 2,
          StudioId: 46,
        },
      ],
      Id: 564,
      Image:
        'https://static.schumacherhomes.com/public/assets/homes/rrrBelleville-Coastal.jpg',
      IsBaseElevation: false,
      IsPopular: false,
      IsPreferred: false,
      Name: 'Belleville Coastal',
      PopularRank: 0,
      SquareFeet: 3182,
      Width: 102,
      HasFloorPlans: true,
      Plan: {
        Bathrooms: 3,
        Bedrooms: 4,
        Collection: null,
        FlexRoom: true,
        FlexRoomIsBedroom: true,
        HasGarage: true,
        Id: 164,
        IsMultiGen: false,
        Name: 'Belleville',
        SimilarPlans: [
          {
            SimilarPlanId: 28,
          },
          {
            SimilarPlanId: 100,
          },
          {
            SimilarPlanId: 136,
          },
        ],
        Stories: [
          {
            Id: 4,
            Name: "2 Story Owner's Retreat Down",
          },
          {
            Id: 7,
            Name: "Dual Owner's Retreat",
          },
        ],
      },
      objectID: '164_564_46',
    },
  ],
  'Beverly II': [
    {
      indexName: 'dev_house_plans_elevations',
      BaseElevationPrice: 12345,
      Depth: 54,
      ExteriorStyle: {
        Id: 9,
        ExteriorStyleCategoryId: 7,
        Name: 'Carolina',
      },
      FloorPlans: [
        {
          BasePrice: 467159,
          ElevationId: 64,
          FloorPlanImages: [
            {
              FileName:
                'https://static.schumacherhomes.com/public/assets/floorplanimages/BEVERLY_II_MW1.jpg',
              Type: 'Main Story',
              TypeId: 1,
            },
            {
              FileName:
                'https://static.schumacherhomes.com/public/assets/floorplanimages/BEVERLY-II_BEDROOM-4_MW.jpg',
              Type: 'Design Idea',
              TypeId: 5,
            },
            {
              FileName:
                'https://static.schumacherhomes.com/public/assets/floorplanimages/BEVERLY-II_DELUXE-KITCHEN_MW.jpg',
              Type: 'Design Idea',
              TypeId: 5,
            },
          ],
          HasModelHome: true,
          Id: 1325,
          IsPopular: true,
          IsPreferred: true,
          PlanId: 17,
          PopularRank: 5,
          StudioId: 24,
        },
        {
          BasePrice: 467159,
          ElevationId: 64,
          FloorPlanImages: [
            {
              FileName:
                'https://static.schumacherhomes.com/public/assets/floorplanimages/BEVERLY_II_MW1.jpg',
              Type: 'Main Story',
              TypeId: 1,
            },
            {
              FileName:
                'https://static.schumacherhomes.com/public/assets/floorplanimages/BEVERLY-II_BEDROOM-4_MW.jpg',
              Type: 'Design Idea',
              TypeId: 5,
            },
            {
              FileName:
                'https://static.schumacherhomes.com/public/assets/floorplanimages/BEVERLY-II_DELUXE-KITCHEN_MW.jpg',
              Type: 'Design Idea',
              TypeId: 5,
            },
          ],
          HasModelHome: true,
          Id: 1325,
          IsPopular: true,
          IsPreferred: true,
          PlanId: 17,
          PopularRank: 5,
          StudioId: 24,
        },
      ],
      Id: 64,
      Image:
        'https://static.schumacherhomes.com/public/assets/homes/Exterior-Beverly-II-Belmont-23.jpg',
      IsBaseElevation: false,
      IsPopular: false,
      IsPreferred: false,
      Name: 'Beverly II Carolina',
      PopularRank: 0,
      SquareFeet: 2428,
      Width: 90,
      HasFloorPlans: true,
      Plan: {
        Bathrooms: 2,
        Bedrooms: 3,
        Collection: null,
        FlexRoom: true,
        FlexRoomIsBedroom: true,
        HasGarage: true,
        Id: 17,
        IsMultiGen: false,
        Name: 'Beverly II',
        SimilarPlans: [
          {
            SimilarPlanId: 15,
          },
          {
            SimilarPlanId: 31,
          },
          {
            SimilarPlanId: 133,
          },
        ],
        Stories: [
          {
            Id: 1,
            Name: '1 Story',
          },
        ],
      },
      objectID: '17_64_24',
    },
    {
      indexName: 'dev_house_plans_elevations',
      Depth: 54,
      ExteriorStyle: {
        Id: 9,
        ExteriorStyleCategoryId: 7,
        Name: 'Carolina',
      },
      FloorPlans: [
        {
          BasePrice: 457900,
          ElevationId: 64,
          FloorPlanImages: [
            {
              FileName:
                'https://static.schumacherhomes.com/public/assets/floorplanimages/BEVERLY_II_CAR.jpg',
              Type: 'Main Story',
              TypeId: 1,
            },
            {
              FileName:
                'https://static.schumacherhomes.com/public/assets/floorplanimages/BEVERLY-II_BEDROOM-4_CAR.jpg',
              Type: 'Design Idea',
              TypeId: 5,
            },
            {
              FileName:
                'https://static.schumacherhomes.com/public/assets/floorplanimages/BEVERLY-II_DELUXE-KITCHEN_CAR.jpg',
              Type: 'Design Idea',
              TypeId: 5,
            },
          ],
          HasModelHome: true,
          Id: 1318,
          IsPopular: true,
          IsPreferred: true,
          PlanId: 17,
          PopularRank: 6,
          StudioId: 15,
        },
      ],
      Id: 64,
      Image:
        'https://static.schumacherhomes.com/public/assets/homes/Exterior-Beverly-II-Belmont-23.jpg',
      IsBaseElevation: false,
      IsPopular: false,
      IsPreferred: false,
      Name: 'Beverly II Carolina',
      PopularRank: 0,
      SquareFeet: 2428,
      Width: 90,
      HasFloorPlans: true,
      Plan: {
        Bathrooms: 2,
        Bedrooms: 3,
        Collection: null,
        FlexRoom: true,
        FlexRoomIsBedroom: true,
        HasGarage: true,
        Id: 17,
        IsMultiGen: false,
        Name: 'Beverly II',
        SimilarPlans: [
          {
            SimilarPlanId: 15,
          },
          {
            SimilarPlanId: 31,
          },
          {
            SimilarPlanId: 133,
          },
        ],
        Stories: [
          {
            Id: 1,
            Name: '1 Story',
          },
        ],
      },
      objectID: '17_64_15',
    },
    {
      indexName: 'dev_house_plans_elevations',
      Depth: 54,
      ExteriorStyle: {
        Id: 10,
        ExteriorStyleCategoryId: 5,
        Name: 'Modern Hill Country',
      },
      FloorPlans: [
        {
          BasePrice: 462870,
          ElevationId: 453,
          FloorPlanImages: [
            {
              FileName:
                'https://static.schumacherhomes.com/public/assets/floorplanimages/BEVERLY_II_CAR.jpg',
              Type: 'Main Story',
              TypeId: 1,
            },
            {
              FileName:
                'https://static.schumacherhomes.com/public/assets/floorplanimages/BEVERLY-II_BEDROOM-4_CAR.jpg',
              Type: 'Design Idea',
              TypeId: 5,
            },
            {
              FileName:
                'https://static.schumacherhomes.com/public/assets/floorplanimages/BEVERLY-II_DELUXE-KITCHEN_CAR.jpg',
              Type: 'Design Idea',
              TypeId: 5,
            },
          ],
          HasModelHome: true,
          Id: 1392,
          IsPopular: true,
          IsPreferred: true,
          PlanId: 17,
          PopularRank: 9,
          StudioId: 11,
        },
      ],
      Id: 453,
      Image:
        'https://static.schumacherhomes.com/public/assets/homes/rrbeverly-ii-modernhillcountry.jpg',
      IsBaseElevation: false,
      IsPopular: false,
      IsPreferred: false,
      Name: 'Beverly II Modern Hill Country',
      PopularRank: 0,
      SquareFeet: 2428,
      Width: 90,
      HasFloorPlans: true,
      Plan: {
        Bathrooms: 2,
        Bedrooms: 3,
        Collection: null,
        FlexRoom: true,
        FlexRoomIsBedroom: true,
        HasGarage: true,
        Id: 17,
        IsMultiGen: false,
        Name: 'Beverly II',
        SimilarPlans: [
          {
            SimilarPlanId: 15,
          },
          {
            SimilarPlanId: 31,
          },
          {
            SimilarPlanId: 133,
          },
        ],
        Stories: [
          {
            Id: 1,
            Name: '1 Story',
          },
        ],
      },
      objectID: '17_453_11',
    },
  ],
} as TGroupedHome;
